/* eslint-disable  react/prop-types */

import React from 'react';

const WarningIcon = ({ width = 16, height = 16, style = {} }) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="warning-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8 3C8.55229 3 9 3.44772 9 4V8C9 8.55229 8.55228 9 8 9C7.44771 9 7 8.55228 7 8V4C7 3.44772 7.44772 3 8 3ZM9 11.2C9 10.6477 8.55228 10.2 8 10.2C7.44772 10.2 7 10.6477 7 11.2V12C7 12.5523 7.44771 13 8 13C8.55228 13 9 12.5523 9 12V11.2Z"
      fill="#B02525"
    />
  </svg>
);

export default WarningIcon;
